import React from 'react'

/**
 * The MLMind mark: an "M" drawn as a small neural network, with the
 * accent node where the strokes meet. Same geometry as public/logo-mark.svg
 * (the master the favicon and PNG icons are rendered from — see
 * scripts/generate-brand-assets.js); change both together.
 *
 * Decorative by default; pass `title` when the mark is the only thing that
 * names the link or button it sits in. `tone="light"` draws it in white for
 * dark backgrounds.
 */
const LogoMark = ({ size = 32, title, tone = 'ink', className = '' }) => {
  const ink = tone === 'light' ? '#ffffff' : '#111111'
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 64 64'
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : 'true'}
      focusable='false'
    >
      {title && <title>{title}</title>}
      <polyline
        points='12,52 12,14 32,36 52,14 52,52'
        fill='none'
        stroke={ink}
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='12' cy='52' r='5' fill={ink} />
      <circle cx='12' cy='14' r='5' fill={ink} />
      <circle cx='52' cy='14' r='5' fill={ink} />
      <circle cx='52' cy='52' r='5' fill={ink} />
      <circle cx='32' cy='36' r='7' fill='#e7ff02' stroke='#111111' strokeWidth='3' />
    </svg>
  )
}

export default LogoMark
